import { Type } from 'class-transformer';
import { EmailReferenceParameterDto } from '../../_models/email-reference-parameter-dto';
import { WorkOrderRawDto } from './work-order-raw-dto';

export class AddWorkOrderParametersDto extends WorkOrderRawDto {
    linkedTaskId: number;
    workflowId: number;
    vendorCode: string;

    @Type(() => EmailReferenceParameterDto)
    emailReference: EmailReferenceParameterDto;

    emailAttachmentFileNames: Array<string>;
}
